<div class="totaalactivatie">
  <span>{{data}}%</span>
</div>
